










































import { Vue, Component } from "vue-property-decorator";
import { IReportType } from "@/models/reports";

@Component({
  components: {
    "report-types-provider": () =>
      import("@/components/app/admin/insights/reportTypesProvider.vue")
  }
})
export default class ReportTypesListing extends Vue {
  public reportRoute(report?: IReportType) {
    if (!report) return;
    return {
      name: "upmReportsReportOverview",
      params: {
        reportCode: report.code
      }
    };
  }
}
